import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import qs from 'qs'

import { defaultInstance } from 'services'

import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'

const getStatuses = () => {
  return [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ]
}

const statuses = getStatuses()

const getStatusByValue = (value) => {
  return _.find(statuses, { value })
}

export const mapFieldUser = (item, index) => {
  const id = item?.user_id
  const orgStructure = item?.employee?.org_structure
  return {
    index,
    key: uuidv4(),
    id: id,
    name: item?.employee?.employee_name_th,
    organization: `${orgStructure?.company?.company_name}/${orgStructure?.group?.group_name}/${orgStructure?.business_unit?.bu_name}/${orgStructure?.division?.division_name}/${orgStructure?.department?.department_name}/${orgStructure?.section?.section_name}`,
    profile: item?.profile_id,
    role: item?.profile?.role?.role_name || 'None',
    isEnabled: item?.is_active,
    status: getStatusByValue(item?.is_active),
    canEdit: item?.can_edit,
  }
}

export const getUserListApi = ({
  company_id,
  group_id,
  bu_id,
  division_id,
  department_id,
  section_id,
  profile_id,
  role_id,
  employee_name,
  is_active,
  page,
  size,
}) => {
  const params = removeEmpty({
    company_id,
    group_id,
    bu_id,
    division_id,
    department_id,
    section_id,
    profile_id,
    role_id,
    employee_name,
    is_active,
    page,
    size,
  })

  const config = {
    method: 'get',
    url: '/api/v1/user/',
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data?.items) {
        return responseSuccess({
          data: {
            items: _.map(res.data?.items, mapFieldUser),
            total: res.data.total,
            page: res.data.page,
            size: res.data.size,
          },
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({ message: err.response.data?.detail })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateUserByIdApi = ({ user_id, profile_id, is_active }) => {
  const params = {
    profile_id,
    is_active,
  }

  const config = {
    method: 'patch',
    url: `/api/v1/user/${user_id}`,
    params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getAllUser = () => {
  const config = {
    method: 'get',
    url: `/api/v1/filters/user`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const importUserLDAPApi = () => {
  const config = {
    method: 'post',
    url: `/api/v1/ldap/user/import`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
